<template>
  <div :class="video_popup_class">
    <div class="popup_video_container relative" @click="prevent_close($event)">
      <div class="mx-auto loading-app">
        <img src="../../assets/loading.svg" class="mx-auto w-32 inline-block" />
      </div>
      <video-player
        :options="playerOptions"
        :playsinline="true"
        @loadeddata="video_started"
        @ended="on_video_ended($event)"
      />
      <!--          <video :src="video_src" @loadeddata="video_started" @ended="close_popup" autoplay controls muted></video>-->
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from "vuex";
export default {
  name: "sub_video",
  data() {
    return {
      loading: "loading"
    };
  },
  props: ["item"],
  computed: {
    ...mapState([
      "current_section",
      "current_sub_section",
      "current_secondary_section",
      "current_secondary_sub_section",
      "sections_content"
    ]),
    ...mapGetters(["eventTag"]),
    page_url() {
      var str = "/popups/video/" + this.$store.state.popup_video_src;
      if (this.$store.state.app_type == "mobile") {
        str = "/mobile" + str;
      }
      return str;
    },

    video_src() {
      return (
        "static/content/" +
        this.selected_section +
        "/" +
        this.selected_sub_section +
        "/pdf/" +
        this.item.filename +
        "." +
        (this.item.has_mp4 ? "mp4" : "webm")
      );
    },
    video_popup_class() {
      return "internal-video " + this.loading;
    },
    playerOptions() {
      return {
        sources: [
          {
            type: "video/mp4",
            src: this.video_src
          }
        ]
      };
    },
    selected_section() {
      if (this.current_secondary_section != "") {
        return this.current_secondary_section;
      }
      return this.current_section;
    },
    selected_sub_section() {
      if (this.current_secondary_sub_section != "") {
        return this.current_secondary_sub_section;
      }
      return this.current_sub_section;
    }
  },
  methods: {
    on_video_ended(e) {
      this.$ga.event(
        this.eventTag + "-video_events",
        "end",
        this.$store.state.popup_video_src,
        1
      );
    },

    close_popup(e) {
      console.log("close popup");

      this.loading = "loading";
      //this.$bus.$emit('send_unity_msg', 'OnVideoPopupClose', null)
    },
    prevent_close(e) {
      e.stopPropagation();
    },
    video_started() {
      this.loading = "";

      this.$ga.event(
        this.eventTag + "-video_events",
        "start",
        this.$store.state.popup_video_src,
        1
      );
    }
  },
  mounted() {
    this.$store.dispatch("set_simple_val", {
      name: "ambience_previous_vol",
      val: this.$store.state.ambience_current_vol
    });

    this.$bus.$emit("on-video-created");
    this.$bus.$emit("on-request-ambience-fade", 0);
  },
  beforeDestroy() {
    if (
      this.$store.state.ambience_previous_vol >= 0 &&
      this.$store.state.ambience_previous_vol !=
        this.$store.state.ambience_current_vol
    ) {
      this.$bus.$emit(
        "on-request-ambience-fade",
        this.$store.state.ambience_max_volume
      );
    }
  }
};
</script>

<style scoped>
.loading-app {
  display: none;
  position: absolute;
  top: 50%;
  left: 0;
  width: 100%;
  transform: translateY(-50%);
}
.loading .loading-app {
  display: block;
}
.loading .video-player {
  opacity: 0;
}
.popup_video_container .video-player {
  opacity: 1;
  transition: opacity 0.4s;
}

.app-popup-instructions {
  background: rgba(20, 20, 20, 0.8);
  text-transform: uppercase;
}

@media only screen and (max-width: 1110px) {
  .option-bar {
    top: -50px;
    right: 0;
  }
}
@media only screen and (max-width: 1110px) and (max-height: 460px) {
  .option-bar {
    top: 5px !important;
    right: 5px !important;
  }
}
</style>
<style>
.popup_video_container {
  max-width: 90%;
  margin: 0 auto;
  xmax-height: 60vh;
}
.video-js .vjs-volume-panel {
  display: none !important;
}
.video-js .vjs-control-bar {
  display: flex !important;
  bottom: -3em !important;
  visibility: visible !important;
  opacity: 1 !important;
}
.video-js {
  width: auto !important;
  height: auto !important;
}
body .internal-video .video-js video {
  width: 100% !important;
  height: auto !important;
  max-width: 90vw;
  max-height: 60vh;

  position: relative !important;
}
</style>



// WEBPACK FOOTER //
// src/components/subpopups/video.vue